import type { IAnswer } from "@/types/types";
import { useState, type FC } from "react";
import AnswerModalHeader from "./AnswerModalHeader";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import AnswerForm from "./AnswerForm";
import AnswerModalContent from "./AnswerModalContent";
import { Modal } from "@/components/modal/Modal";
import { EditableAnswer } from "./shared";

interface OpenAnswerProps {
  item: IAnswer;
  idx: number;
}

const OpenAnswer: FC<OpenAnswerProps> = ({ item, idx }) => {
  const [open, setOpen] = useState(false);
  const [edition, setEdition] = useState(false);
  const translation = useTranslate();

  const handleOnOpenAndEdit = () => {
    setEdition(true);
    setOpen(true);
  };
  const handleOnOpen = () => {
    setOpen(true);
  };

  const handleOnClose = () => {
    setOpen(false);
    setEdition(true);
  };

  return (
    <>
      <div className="flex group w-full text-left border border-ib-gray-borders p-2 rounded-sm bg-white cursor-pointer   h-32">
        <EditableAnswer
          item={item}
          handleOnOpenAndEdit={handleOnOpenAndEdit}
          handleOnOpen={handleOnOpen}
        />
      </div>
      {open && (
        <Modal>
          <Modal.Header>
            <AnswerModalHeader
              close={handleOnClose}
              fase={item.phaseId}
              title={`${translation("action")} ${idx}`}
              setEdition={setEdition}
              edition={edition}
            />
          </Modal.Header>
          <Modal.Content>
            {edition ? (
              <AnswerForm onClose={handleOnClose} item={item} />
            ) : (
              <AnswerModalContent
                item={item}
                edition={edition}
                editable
                edit={handleOnOpenAndEdit}
              />
            )}
          </Modal.Content>
        </Modal>
      )}
    </>
  );
};

export default OpenAnswer;
